import { NeoReport, Report } from "@singularsystems/neo-reporting";
import BankTransferLetterCriteria from "./BankTransferLetterCriteria";

@NeoReport("BankTransferLetter", { hidden: true })
export default class BankTransferLetterReport extends Report<BankTransferLetterCriteria> {

    constructor() {
        super(BankTransferLetterCriteria);
    }

    public renderCriteria() {
        return <div>
        </div>;
    }
}